/**
 * Renders a read-only view of the attributes of a given `Plugin`.
 * ## Fields
 * Name | Description
 * --- | ---
 * model | The `Plugin` model associated with the view.
 * @module app/views/admin/applications/Details
 */
import Backbone from "backbone";
import _ from "underscore";
import Field from "core/models/Field";
import Plugin from "app/models/Plugin";
import DetailView from "core/views/DetailView";
import GroupCollection from "app/models/GroupCollection";
import PermissionView from "app/views/admin/permissions/Editor";
import viewTemplate from "views/admin/plugins/Details";
import ErrorUtils from "app/utils/ErrorUtils";
import Helper from "app/ejs";
import messenger from "app/Messenger";
export default Backbone.View.extend({
  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {Plugin} options.model The model to display.
   */
  initialize: function (options) {
    this.options = options;

    this.model = this.options.model;
  },

  template: Helper.template(viewTemplate),
  className: "application-details",

  events: {
    "click .show-secret": function () {
      this.$(".secret").attr("type", "text");
    },
    "click .reset-secret": function () {
      this.model
        .resetSecret()
        .fail(
          ErrorUtils.errorHandler({
            activity: "resetting the secret",
          })
        )
        .done(function () {
          messenger.success("Secret reset successfully.");
        })
        .always(
          _.bind(function () {
            this.render();
          }, this)
        );
    },
  },

  render: function () {
    this.$el.html(this.template(this.options));

    var detailView = new DetailView({
      model: this.model,
      fields: [
        new Field(Plugin.fields["Domain"]),
        new Field(Plugin.fields["menuName"]),
        new Field(Plugin.fields["adminMenuName"]),
        new Field(Plugin.fields["slug"]),
        new Field(Plugin.fields["stylesheet"]),
        new Field(Plugin.fields["ApplicationKey"]),
      ],
    });

    detailView.render();
    this.$(".static-details").append(detailView.$el);

    var groups = new GroupCollection([]);
    var self = this;

    groups.fetch({
      success: function () {
        var actions;

        actions = {
          access: "Access the main entry point of the application.",
          administer:
            "Update the application and access the administrative entry point of the application.",
        };

        var permissionView = new PermissionView({
          groups: groups.models,
          type: {
            Application: self.model.id,
          },
          actions: actions,
          allowPublic: true,
        });

        permissionView.render();
        permissionView.$el.appendTo(
          self.$(".permissions-tab .slider-outer .slider-content")
        );
      },
      error: ErrorUtils.apiHandler({
        activity: "loading the groups",
      }),
    });
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/admin/applications/Details.js
// module id = 935
// module chunks = 1